<template>
  <!-- Quick way to change the spinner in IFrames for all pages -->
  <div v-if="$rsGlobals.$isIFrame" class="rs-spin text-center">
    <RsIFrameSpin />
  </div>
  <div v-else class="rs-spin text-center">
    <i class="fas fa-spinner fa-spin fa-3x" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RsIFrameSpin from './RsIFrameSpin.vue';

export default defineComponent({
  name: 'RsSpin',
  components: { RsIFrameSpin },
});
</script>

<style scoped lang="scss">
@import '@/styles/_variables';

.rs-spin {
  color: $primary-color;
}

</style>
